<template>
  <div>
    <div class="header"></div>
    <div class="news">
      <!-- 导航栏 -->
      <div class="tab">
        <ul>
          <li
            :class="tabIndex == 0 ? 'active' : ''"
            @click="(arrow = '关于协会'), (tabIndex = 0)"
          >
            关于协会
          </li>
          <li
            :class="tabIndex == 1 ? 'active' : ''"
            @click="(arrow = '协会章程'), (tabIndex = 1)"
          >
            协会章程
          </li>
          <li
            :class="tabIndex == 2 ? 'active' : ''"
            @click="(arrow = '规章制度'), (tabIndex = 2)"
          >
            规章制度
          </li>
        </ul>
        <div class="crumbs">
          <img src="../../../../static/wy/icon_shouye.png" alt="" />
          <span @click="$router.push('/home')">首页</span>
          <img src="../../../../static/wy/icon_jiantou.png" alt="" />
          <span>{{ arrow }}</span>
        </div>
      </div>
      <div class="regard" v-show="tabIndex == 0">
        <!-- <h1>协会简介</h1> -->
        <img src="../../../../static/wy/gylogin.png" alt="" />
        <div class="regard-bottom">
          <span
            >深圳市司法鉴定协会成立于2019年12月28日，是深圳市司法鉴定行业的自律性组织，依法对全市司法鉴定行业实施行业服务和管理。深圳市司法鉴定协会的业务主管单位为深圳市司法局，协会在司法鉴定管理工作中充分发挥自我约束、自律发展、教育培训、对外发展的作用，其主要职能包括：宣传司法鉴定有关法律、法规、规章和政策，搞好为会员服务的工作，保障会员依法执业，维护行业利益，维护会员的合法权益；研究司法鉴定工作中的新情况、新问题，配合政府有关部门制定相关的规章制度；接受政府有关部门委托，制定司法鉴定人各类教育培训计划并组织实施；组织行业间各种交流活动；协调行业内、外部关系，向有关部门反映会员的意见和建议等。</span
          >
          <span
            >协会设秘书处，是本会的执行机构，负责具体落实代表大会、理事会和会长办公会议的各项决议、决定，承担本会的日常工作。协会下设法医学专业委员会、精神病专业委员会、法医物证专业委员会、理化（毒品毒物、微量物证）专业委员会、痕迹专业委员会、文检专业委员会、交通专业委员会、环损专业委员会、声像资料（及其他）专业委员会等九个专业委员会，分别负责专业相关事务。</span
          >
        </div>
      </div>
      <div class="constitution" v-show="tabIndex == 1">
        <ruleDom></ruleDom>
      </div>
      <div class="regimeDom" v-show="tabIndex == 2">
        <regimeDom />
      </div>
    </div>
  </div>
</template>

<script>
import ruleDom from './ruleDom';
import regimeDom from './regimeDom';
export default {
  components:{
    ruleDom,
    regimeDom
  },
  data() {
    return {
      arrow: "关于协会",
      tabIndex: 0,
      page: 0,
    };
  },
  methods: {
    skip(index) {
      if (index == 1) {
        if (this.page == 0) {
          return;
        } else {
          this.page -= 1;
        }
      } else {
        if (this.page == 6) {
          this.$message({
          message: '已经是最后一页了!',
          type: 'warning'
        });
        } else {
          this.page += 1;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 1920px;
  height: 400px;
  background: url("../../../../static/wy/banner3.png") no-repeat center center;
  background-size: 100% 100%;
}
.news {
  width: 70%;
  background: url("../../../../static/wy/bj.png") no-repeat;
  // background-size: 100% 100%;
  margin: 0 auto;
  margin-top: -90px;
  overflow: hidden;
  margin-bottom: 120px;
  // 导航栏
  .tab {
    width: 85%;
    height: 46px;
    margin: 0 auto;
    margin-top: 70px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    ul {
      height: 100%;
      display: flex;
      justify-content: space-between;
      li {
        display: inline-block;
        width: 120px;
        height: 46px;
        font-size: 18px;
        font-weight: 600;
        line-height: 46px;
        text-align: center;
        cursor: pointer;
      }
      .active {
        background-color: #f2f2f2;
        color: red;
        border-bottom: 2px solid red;
        position: relative;
        font-size: 20px;
      }
      .active::after {
        content: "";
        position: absolute;
        left: 46%;
        bottom: -6px;
        border-width: 0 6px 6px;
        border-style: solid;
        border-color: transparent transparent red;
        transform: rotate(180deg);
      }
    }
    .crumbs {
      height: 100%;
      display: flex;
      align-items: center;
      img {
        margin-right: 5px;
      }
      img:nth-child(1) {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
      img:nth-child(2) {
        width: 8px;
        height: 16px;
      }
      span {
        display: inline-block;
        margin-right: 6px;
        color: #9a9a9a;
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
      }
    }
  }
  .regard {
    // h1{
    //   margin: 40px 0 40px 40%;
    // }
    img {
      margin: 40px 0 40px 34%;
    }
    .regard-bottom {
      width: 85%;
      height: 322px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      span {
        width: 100%;
        text-indent: 2em;
        font-size: 18px;
        // font-weight: 600;
        line-height: 33px;
      }
    }
  }
}
</style>
